import { Link } from "react-router-dom";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";

const services = [
  {
    en: "Talent Management",
    ja: "タレントマネジメント事業",
    path: "/entertainment",
    image: "https://storage.googleapis.com/studio-design-asset-files/projects/EXaw2V5pqD/s-1566x1046_v-fms_webp_f21bca1b-2b2f-4fb9-a2a0-45cc80ff6353_small.webp",
    description:
      "大分県を拠点に独自のタレントマネジメント事業を展開しています。地元密着型の強みを活かし、幅広いメディア出演やタレント活動を行うほか、教育活動として学校講演も実施しています。",
  },
  {
    en: "Farm",
    ja: "ファーム事業",
    path: "/farm",
    image: "https://storage.googleapis.com/studio-design-asset-files/projects/EXaw2V5pqD/s-1567x1045_v-fms_webp_320f49bc-c8c6-4254-b606-1ecc368e9a76_small.webp",
    description:
      "温暖な気候と豊かな土壌に恵まれた大分県で、伝統と革新が調和する果樹園経営を展開しています。300年以上の歴史を持つカボスの発祥地で本格的な栽培を行っています。",
  },
  {
    en: "EC site",
    ja: "EC事業",
    path: "/ec",
    external: "https://olcompany.base.shop/",
    image: "https://storage.googleapis.com/studio-design-asset-files/projects/EXaw2V5pqD/s-4080x3072_v-frms_webp_69b5475f-7644-40f8-b9bd-89073b834090_small.webp",
    description:
      "弊社オリジナルブランド商品を開発し、ローカルの輝きを世界にシェアしていきます。ファーム事業で生産したカボスのみならず、アパレルの販売も行います。",
  },
];

export default function ServiceSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-3 md:py-6 px-3 md:px-6 lg:px-8 bg-[#f0efef]">
      <div className="max-w-7xl mx-auto bg-[#f0efef] rounded-[20px] overflow-hidden">
        <div className="p-4 md:p-8 lg:p-10">
          <div ref={ref} className={getRevealClass(isVisible)}>
            <div className="mb-8 md:mb-14">
              <h2 className="text-3xl lg:text-4xl font-bold text-black tracking-tight mb-1 text-center md:text-left">Service</h2>
              <p className="text-sm text-gray-400 mb-4 text-center md:text-left">事業内容</p>
              <div className="w-8 h-px bg-black mx-auto md:mx-0" />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {services.map((service) => {
              const inner = (
                <div className="group cursor-pointer text-center md:text-left">
                  <div className="w-full aspect-[68/45] overflow-hidden mb-5 rounded-xl">
                    <img
                      src={service.image}
                      alt={service.ja}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <p className="text-[10px] tracking-[0.3em] text-gray-400 uppercase mb-1 text-center md:text-left">{service.en}</p>
                  <h3 className="text-lg font-bold text-black mb-3 text-center md:text-left">{service.ja}</h3>
                  <div className="w-6 h-px bg-black mb-3 mx-auto md:mx-0" />
                  <p className="text-xs text-gray-500 leading-relaxed mb-4 text-center md:text-left">{service.description}</p>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold tracking-wider text-black border-b border-black pb-0.5 group-hover:gap-2 transition-all whitespace-nowrap mx-auto md:mx-0">
                    詳しく見る <i className="ri-arrow-right-line" />
                  </span>
                </div>
              );

              if (service.external) {
                return (
                  <a key={service.en} href={service.external} target="_blank" rel="noopener noreferrer">
                    {inner}
                  </a>
                );
              }
              return (
                <Link key={service.en} to={service.path}>
                  {inner}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
